import React, { useState, useEffect } from 'react';
import { doc, getDoc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, auth } from '../firebase-config';
import { deleteUser } from "firebase/auth";
import { Container, Typography, Grid, TextField, Button, Card, CardContent } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function Profile() {
  const [user, setUser] = useState({});
  const [editMode, setEditMode] = useState(false);

  const [newPhone, setNewPhone] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUser = async () => {
      const docRef = doc(db, "users", auth.currentUser.uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setUser(docSnap.data());
        setNewPhone(docSnap.data().phone);
      }
    };
    fetchUser();
  }, []);

  const handleUpdateProfile = async () => {
    const userRef = doc(db, "users", auth.currentUser.uid);
    await updateDoc(userRef, {
      firstName: user.firstName,
      lastName: user.lastName,
      phone: newPhone,
    });
    alert("Profil został zaktualizowany!");
    setEditMode(false);
  };

  const handleDeleteAccount = async () => {
    const confirm = window.confirm("Czy na pewno chcesz usunąć swoje konto?");
    if (!confirm) {
      return;
    }
    try {
      const userRef = doc(db, "users", auth.currentUser.uid);
      await deleteDoc(userRef);
      await deleteUser(auth.currentUser);
      alert("Twoje konto użytkownika zostało usunięte.");
      navigate('/');
    } catch (error) {
      console.error("Błąd podczas usuwania konta: ", error);
      alert("Nie udało się usunąć konta.");
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <Card sx={{ mt: 4, bgcolor: 'background.paper', boxShadow: 3 }}>
        <CardContent>
          <Typography component="h1" variant="h5" gutterBottom style={{ textAlign: 'center', fontWeight: 'bold', textDecoration: 'underline' }}>
            Twój profil:
          </Typography>
          {!editMode ? (
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={6}>
                <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 'bold' }}>Imię:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{user.firstName}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 'bold' }}>Nazwisko:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{user.lastName}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 'bold' }}>Adres e-mail:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{user.email}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1" color="textSecondary" sx={{ fontWeight: 'bold' }}>Numer telefonu:</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="body1">{user.phone}</Typography>
              </Grid>
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Button variant="contained" onClick={() => setEditMode(true)}>Edytuj dane</Button>
                <Button variant="contained" color="error" onClick={handleDeleteAccount} sx={{ ml: 2 }}>Usuń konto</Button>
              </Grid>
            </Grid>
          ) : (
            <>
              <TextField margin="normal" fullWidth label="Imię" value={user.firstName} onChange={(e) => setUser({...user, firstName: e.target.value})} />
              <TextField margin="normal" fullWidth label="Nazwisko" value={user.lastName} onChange={(e) => setUser({...user, lastName: e.target.value})} />
              <TextField margin="normal" fullWidth label="Numer telefonu" value={newPhone} onChange={(e) => setNewPhone(e.target.value)} />
              <Button onClick={handleUpdateProfile}>Zapisz zmiany</Button>
              <Button onClick={() => setEditMode(false)}>Anuluj</Button>
            </>
          )}
        </CardContent>
      </Card>
    </Container>
  );
}

export default Profile;
